<template>
    <vue-table
        :api-mode="false"
        :fields="tableFields"
        :data="rowData.lines"
        noDataTemplate="No se encontraron resultados"
    >
      <template slot="percentageFromTotal" slot-scope="props">
          <div class="progressContainer text-center">
            <div class="progressBar">
                  <div :style="'font-size: 14px;margin:-5px 10px;float:left'">{{formatPercentage(props.rowData.percentageFromTotal)}}</div>
              <div v-if="window.width > 620" class="progress table-bar">
                <div :class="'progress-bar progress-bar-'+ formatProgress(props.rowData.percentageFromTotal) " role="progressbar"
                  aria-valuemin="0" aria-valuemax="100" :style="'width:' + formatPercentage(props.rowData.percentageFromTotal)">
                </div>
              </div>
            </div>
            </div>
      </template>

      <template slot="quantity" slot-scope="props">
        <span>{{formatAmount(props.rowData.quantity)}}<span style="font-size:12px"> {{props.rowData.minimumStockUnit}}</span></span>
      </template>
    </vue-table>
</template>

<script>
import Vuetable from 'vuetable-2'

export default {
  props: {
    rowData: {type: Object, required: true},
    rowIndex: {type: Number}
  },
  data () {
    return {
      tableFields: [
        {
          name: 'line',
          title: 'Línea'
        },
        {
          name: '__slot:percentageFromTotal',
          title: 'Porcentaje'
        },
        {
          name: '__slot:quantity',
          title: 'Cantidad'
        }
      ],
      tableData: [],
      window: {
        width: 0,
        height: 0
      }
    }
  },
  components: {
    'vue-table': Vuetable
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    onClick (event) {
    },
    formatProgress (documentProgress) {
      let classVal = ''

      if (documentProgress > 0) {
        classVal = 'success'
      }

      return classVal
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    formatAmount (value) {
      return this.$options.filters.formatAmount(value)
    },
    formatPercentage (value) {
      return this.$options.filters.formatPercentage(value) + '%'
    }
  }
}
</script>



// WEBPACK FOOTER //
// InventoryProductStatusLine.vue?0b009042